import React from 'react'
import Link from 'gatsby-link'
import JobList from '../components/job-list'

class PrivacyPage extends React.Component {
  render() {
    return (
      <div className="job-post" style={{ textAlign: 'left', fontSize: '.8rem'}}>
        <h1>Privacy Policy</h1>
        <h2>1. Scope of Our Website Privacy Policy</h2>
        <p>
          Our Website considers protecting and ensuring safety of user data as
          its top priority. Our Website takes the issue of privacy very
          seriously and would like the users of the Website to know that our
          Website takes all the needed precautions to safeguard and protect user
          data. Consequently, the gathering, storage, analysis and use of data
          during a visit or use of the Website, its services and offers is in
          strict compliance with this privacy policy and the relevant
          legislation. We, at our Website, will only start gathering and
          processing users’ personal data on condition of user providing consent
          to our Website to do so, or if our Website is allowed or required to
          do so by law or legislature.
        </p>
        <p>
          We have written this policy to help you understand how our Website
          gathers, processes, analyses and uses users’ data to provide the
          website services and functionality to users. Our main aim with this
          policy is to comply with relevant legislation and to act, in our best
          ability, to prevent unlawful and offensive use, management, damage,
          destruction or misapplication of users’ data. Our website, to the best
          of its abilities, aims to securely store and process all users’ data.
        </p>

        <h2>2. Data Use and Collection</h2>
        <p>
          The website can be visited without any personal data provided.
          Visitors of the Website can opt to remain anonymous. Our website
          processes anonymous metadata through cookies such as the URL of the
          requested file, the amount of data transferred, the date and time of
          the request from the user, internet browser information, operating
          system type, the IP address of the used device, the internet service
          provider used, reference links such as user clicks on certain links.
          This metadata cannot be used by our website to obtain personally
          identifiable information. This information is only used for general
          purposes, such as technical improvements and statistical purposes.
        </p>
        <p>
          Our Website's will not share personal information with third parties
          unless our users have expressly given their permission to do so. Due
          to legal requirements and to comply with the relevant laws, our
          website is sometimes forced to reveal users personal information in
          certain cases, for example, upon request of the authorities or to
          process payments. Our Website could be required to disclose
          information to appropriate authorities for investigation should that
          be required to do so by virtue of law or to protect itself, its users
          and contractors from potential abuses.
        </p>

        <h2>3. Communications</h2>
        <p>
          Users can opt in to receive a newsletter, this communication includes
          information such as job alerts and new job notifications. Users are
          also always provided with an option to opt out completely from these
          notification. Should you wish to do so, please adjust the settings on
          the relevant page.
        </p>
        <p>
          You might also receive emails that our website believes will be useful
          for you as a user of the website. Such emails might include promotion
          notifications, announcements of new services or products delivered via
          the site, surveys, periodic newsletters, information and updates on
          new functionality or new developments on the site, and event
          information or other promotional or commercial communication. You can
          manage how and when you receive such emails from our website by using
          unsubscribe link inside each email or simply by notifying us to have
          your contact information removed from our email list or registration
          database.
        </p>

        <h2>4. What Information do we collect?</h2>
        <p>
          When you use at the pages on our website, information is automatically
          recorded that identifies, for each page accessed: the type of browser
          and operating system you have used; the IP (Internet Protocol) address
          of the device which has accessed it (example PC, tablet); the date and
          time of your visit to the site; the pages accessed and documents
          downloaded; your top-level domain name (for example .com, .gov, .eu
          etc.); the address of your server; and the previous website visited.
          Our website might have certain codes included on its webpages that
          provides us with information and data on usage of our sites, this
          information includes: the website pages visited; the average duration
          of page view, location previous to visiting the Our Website or
          website; and the navigation behaviour and habits of the user.
        </p>

        <h2>5. Will this policy be ever updated?</h2>
        <p>
          Due to constantly developing legislation that affects privacy
          principles of online users, our website might be required to update or
          otherwise modify this policy to be in line with the updated
          legislation and to comply with the new principles. As soon as the
          policy is updated, our website will endeavour to post an updated
          version on the website, the new policy becomes effective from the
          moment it is posted or updated on the website.
        </p>
      </div>
    )
  }
}

export default PrivacyPage



// WEBPACK FOOTER //
// ./src/pages/privacy.js